import * as moment from 'moment';
import { track } from '../clients/mixpanelClient';
import { Middleware } from 'redux';
import { AppState, AuthState } from '../models';

export const addMetaData = (state: AppState, properties?: {}) => {
  const authState: AuthState = state.authState;
  const expertId: string = authState.expertId || '';
  const provider: string = authState.provider || '';
  const queues: string[] = authState.queues || [];
 
  const metaProps = {
    EventDateTime: moment(new Date()).utc().toJSON(),
    ExpertId: expertId,
    Provider: provider,
    Queues: queues,
  };
  return { ...metaProps, ...properties };
};

export const analyticsMiddleware: Middleware = (store: any) => (next: any) => (action: any) => {
  const state: AppState = store.getState();
  track(action.type, addMetaData(state, action.props));
  const result = next(action);
  return result;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/middleware/analyticsMiddleware.tsx